import React from 'react';
import { typeFromValue } from '../../utils/containerType';
import BarrelOperation from '../barrel/BarrelOperation';
import TruncatedConeOperation from '../truncatedCone/TruncatedConeOperation';
import WeighedContainerOperation from '../weighedContainer/WeighedContainerOperation';
import OtherContainerOperation from '../otherContainer/OtherContainerOperation';

/**
 * Component to render the appropriate operation component based on container type
 */
export default function OperationContainer({
  currentContainerData,
  currentInventoryData,
  setCurrentInventoryData,
  recordOperation,
  nextOperation,
  canGoPrevious,
  canGoNext,
  onPreviousContainer,
  onNextContainer,
  containerSearchOptions,
  onSearchContainer,
  onSelectContainer,
  previousItemFormValues,
}) {
  const containerType = currentContainerData && currentInventoryData.mappingConfig.columns.type?.mapping?.csvName
    ? typeFromValue(currentContainerData[currentInventoryData.mappingConfig.columns.type.mapping.csvName])
    : undefined;

  if (containerType === 'truncated-cone') {
    return (
      <TruncatedConeOperation
        itemData={currentContainerData}
        setInventoryData={setCurrentInventoryData}
        mappingConfig={currentInventoryData.mappingConfig}
        recordOperation={recordOperation}
        nextOperation={nextOperation}
        canGoPrevious={canGoPrevious}
        canGoNext={canGoNext}
        onPreviousContainer={onPreviousContainer}
        onNextContainer={onNextContainer}
        containerSearchOptions={containerSearchOptions}
        onSearchContainer={onSearchContainer}
        onSelectContainer={onSelectContainer}
        previousItemFormValues={previousItemFormValues}
        inventoryData={currentInventoryData}
      />
    );
  }

  if (containerType === 'standing' || containerType === 'laying') {
    return (
      <BarrelOperation
        itemData={currentContainerData}
        setInventoryData={setCurrentInventoryData}
        mappingConfig={currentInventoryData.mappingConfig}
        recordOperation={recordOperation}
        nextOperation={nextOperation}
        canGoPrevious={canGoPrevious}
        canGoNext={canGoNext}
        onPreviousContainer={onPreviousContainer}
        onNextContainer={onNextContainer}
        containerSearchOptions={containerSearchOptions}
        onSearchContainer={onSearchContainer}
        onSelectContainer={onSelectContainer}
        previousItemFormValues={previousItemFormValues}
        inventoryData={currentInventoryData}
      />
    );
  }

  if (containerType === 'weighed-container') {
    return (
      <WeighedContainerOperation
        itemData={currentContainerData}
        setInventoryData={setCurrentInventoryData}
        mappingConfig={currentInventoryData.mappingConfig}
        recordOperation={recordOperation}
        nextOperation={nextOperation}
        canGoPrevious={canGoPrevious}
        canGoNext={canGoNext}
        onPreviousContainer={onPreviousContainer}
        onNextContainer={onNextContainer}
        containerSearchOptions={containerSearchOptions}
        onSearchContainer={onSearchContainer}
        onSelectContainer={onSelectContainer}
        previousItemFormValues={previousItemFormValues}
        inventoryData={currentInventoryData}
      />
    );
  }

  return (
    <OtherContainerOperation
      itemData={currentContainerData}
      setInventoryData={setCurrentInventoryData}
      mappingConfig={currentInventoryData.mappingConfig}
      recordOperation={recordOperation}
      nextOperation={nextOperation}
      canGoPrevious={canGoPrevious}
      canGoNext={canGoNext}
      onPreviousContainer={onPreviousContainer}
      onNextContainer={onNextContainer}
      containerSearchOptions={containerSearchOptions}
      onSearchContainer={onSearchContainer}
      onSelectContainer={onSelectContainer}
      previousItemFormValues={previousItemFormValues}
      inventoryData={currentInventoryData}
    />
  );
}
